import { FuseUsersComponent } from './users.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../../../core/modules/shared.module';

import { NgxPermissionsGuard } from 'ngx-permissions';
import { FuseWidgetModule } from 'app/core/components/widget/widget.module';
import { FuseAddUserComponent } from 'app/main/content/pages/management/users/components/add-user/add-user.component';
import { FuseEditOrViewUserComponent } from 'app/main/content/pages/management/users/components/edit-or-view-user/edit-or-view-user.component';
import { FuseChangePasswordComponent } from 'app/main/content/pages/management/users/components/change-password/change-password.component';

const routes = [
    {
        path: 'pages/management/users',
        component: FuseUsersComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_USERS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        FuseUsersComponent,
        FuseAddUserComponent,
        FuseEditOrViewUserComponent,
        FuseChangePasswordComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule
    ],
    exports: [
        FuseUsersComponent
    ],
    entryComponents: [
        FuseAddUserComponent,
        FuseEditOrViewUserComponent,
        FuseChangePasswordComponent
    ]
})

export class FuseUsersModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/users/users.module.ts